module.exports = __webpack_public_path__ + "img/P1010947.e96d8935.jpg";